import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'; 

import { IconboxTwoComponent } from './iconbox-two.component'; 
import { RouterLink } from '@angular/router';

@NgModule({
  declarations: [IconboxTwoComponent],
  exports: [IconboxTwoComponent],
  imports: [
    CommonModule, 
    RouterLink
  ]
})
export class IconboxTwoModule {}
